module.exports = __webpack_public_path__ + "assets/zifir.101d867e.svg";